class ConstructionQueues {
  constructor(parent) {
    this.queues = [...parent.querySelectorAll('[data-queue]')];
  }

  update(houseIndex) {
    this.queues.forEach((queue, i) => {
      if (i === houseIndex) {
        queue.classList.remove('hidden');
      } else {
        queue.classList.add('hidden');
      }
    });
  }
}

export default ConstructionQueues;
